import { render } from "./FormLIFFField.vue?vue&type=template&id=c9c2e7a2&scoped=true"
import script from "./FormLIFFField.vue?vue&type=script&lang=ts"
export * from "./FormLIFFField.vue?vue&type=script&lang=ts"

import "./FormLIFFField.vue?vue&type=style&index=0&id=c9c2e7a2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c9c2e7a2"

export default script
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QIcon,QBtn,QInput,QSelect,QToggle,QBtnGroup,QField});
